import React, { useContext, useEffect } from 'react'
import ReactGA from 'react-ga4'
import { AppContext } from './context/app'
import { captureGAEvent } from './utils/helper'
import { useLocation } from 'react-router-dom'

const RouteChangeTracker = ({ history }) => {
  const location = useLocation()
  const { accountObj, userObj } = useContext(AppContext)
  ReactGA.initialize('G-36JM8ZHHWD')

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname,
      title: `${accountObj?.name}`,
    })
    captureGAEvent('page_view', 'page_view', 'Page View', {
      url: location.pathname,
      account_name: accountObj?.name,
      user_id: userObj?._id || '',
      user_email: userObj?.email_id || '',
    })
  }, [location])

  return <></>
}

export default RouteChangeTracker
